// THE EVIDENCE-PHOTO LIMITS, defined ONCE and consumed by BOTH sides of the
// wire (D-096). Deliberately a ZERO-IMPORT module with its own package export
// (`@assessly/contracts/files/limits`): the floor PWA enforces the pair
// client-side BEFORE a blob is queued — a queued photo the server will refuse
// is a guaranteed stuck tray entry — and pulling the whole contracts index
// (zod + the OpenAPI registry) into the floor bundle for two constants would
// be the wrong price. The server's purpose catalog
// (`apps/api/.../file-purposes.ts`) builds its photo-purpose specs from the
// same two values via the main export.
//
// The values carry the catalog's own reasoning, moved here with it: phone
// cameras routinely emit 8–12 MB JPEGs, so 20 MB clears them with margin; the
// type list is an exact allowlist, never a prefix match (`image/*` would admit
// `image/svg+xml`, a script-bearing document browsers execute).

export const FILE_PHOTO_CONTENT_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/heic",
] as const;

export const FILE_PHOTO_MAX_BYTES = 20 * 1024 * 1024;
